import { createSlice,
// createAsyncThunk
 } from '@reduxjs/toolkit';
export var initialUIState = {
    fullscreenMap: false,
};
var slice = createSlice({
    name: 'UI',
    initialState: initialUIState,
    reducers: {
        isFullscreenMapToggled: function (state) {
            state.fullscreenMap = !state.fullscreenMap;
        },
    },
});
var reducer = slice.reducer;
export default reducer;
